import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ToastService } from '../toast/toast';

import { DebugService } from './debug.service';

/**
 * The debug log body without any page chrome, so it can be embedded in a host that already
 * provides its own abs-page-layout (e.g. the Warlord settings shell). Use DebugComponent when
 * the debug log is routed as a page in its own right.
 */
@Component({
    standalone: false,
    selector: 'abs-debug-panel',
    template: `
        <div class="gutter-padding">
            <h2>{{ 'GLOBAL.SETTINGS.DEBUG.TITLE' | translate }}</h2>
            <p [innerHTML]="'GLOBAL.SETTINGS.DEBUG.DESCRIPTION' | translate"></p>
            <div class="buttons">
                <ion-button (click)="copyToClipboard(log.value)">{{ 'GLOBAL.SETTINGS.DEBUG.COPY_LOG' | translate }}</ion-button>
            </div>
            <textarea #log readonly="true">{{ (debugService.log$ | async)?.join('\\n') }}</textarea>
        </div>
    `,
    styles: [
        `
            textarea {
                width: 100%;
                height: 400px;
            }
        `
    ]
})
export class DebugPanelComponent {
    constructor(
        public debugService: DebugService,
        private toast: ToastService,
        private translateService: TranslateService
    ) {}

    copyToClipboard(log: string) {
        navigator.clipboard
            .writeText(log)
            .then(() => {
                this.toast.showToast('', this.translateService.instant('GLOBAL.SETTINGS.DEBUG.COPY_SUCCESS'), { color: 'success' });
            })
            .catch(() => {
                this.toast.showToast('', this.translateService.instant('GLOBAL.SETTINGS.DEBUG.COPY_ERROR'), { color: 'danger' });
            });
    }
}
